import React, { useEffect, useState } from "react";
import { firestore } from "../../firebase-config";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";

const PlacementGallery = () => {
  const [placements, setPlacements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      // Query with ordering by timestamp (newest first)
      const q = query(
        collection(firestore, "placements"),
        orderBy("timestamp", "desc")
      );

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const placementsData = snapshot.docs.map((doc) => {
            const data = doc.data();
            console.log("Placement data:", data); // Debug log
            return {
              id: doc.id,
              studentName: data.studentName || "N/A",
              companyName: data.companyName || "N/A",
              imageUrl: data.imageUrl || "",
              timestamp: data.timestamp,
            };
          });
          
          console.log("Total placements:", placementsData.length); // Debug log
          setPlacements(placementsData);
          setLoading(false);
          setError(null);
        },
        (err) => {
          console.error("Error fetching placements:", err);
          setError("Error loading placements: " + err.message);
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } catch (err) {
      console.error("Error setting up listener:", err);
      setError("Error setting up placements listener");
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <p>Loading placements...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", padding: "40px", color: "red" }}>
        <p>{error}</p>
      </div>
    );
  }

  if (placements.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <p>No placements available.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
        Congratulations to Our Placed Students
      </h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {placements.map(({ id, studentName, companyName, imageUrl }) => (
          <div
            key={id}
            style={{
              border: "1px solid #ddd",
              padding: "15px",
              borderRadius: "8px",
              textAlign: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              backgroundColor: "#fff",
              transition: "transform 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
            }}
          >
            <img
              src={imageUrl}
              alt={studentName}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "8px",
                marginBottom: "10px",
              }}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/200x200?text=No+Image";
              }}
            />
            <h3
              style={{
                margin: "10px 0 5px 0",
                fontSize: "1.1em",
                color: "#333",
              }}
            >
              {studentName}
            </h3>
            <p
              style={{
                margin: "5px 0",
                color: "#666",
                fontSize: "0.95em",
                fontWeight: "500",
              }}
            >
              {companyName}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlacementGallery;